/**
 * Что сервер сообщает о своём времени.
 *
 * ЗАЧЕМ. Таймер на сцене задан МЕТКОЙ («до 19:30:00 по серверу»),
 * а не остатком, и считает от неё сам, не тикая по сети (docs/04).
 * Но часы машины стримера врут: OBS ставят на игровые машины, где
 * NTP отключён «чтобы не лагало», и разбег в минуту там не редкость.
 * Без поправки таймер показал бы зрителям чужое время — и, хуже
 * того, разное на двух оверлеях одного канала.
 *
 * Разбор здесь, а не в оверлее, по той же причине, что у громкости:
 * панель показывает ту же сцену, и разойдись поправка — предпросмотр
 * начал бы врать относительно эфира.
 */
/** Метка серверного времени. */
import { decodeMessage } from './message.js';
/**
 * Разбирает сообщения, в которых сервер называет своё время.
 *
 * ДВА ИСТОЧНИКА, И ОБА НУЖНЫ. `welcome` даёт поправку СРАЗУ —
 * до первой отрисовки, чтобы таймер не мигнул чужим числом.
 * `pong` даёт её точнее и продолжает давать: часы расходятся
 * и во время эфира, а эфир идёт часами.
 *
 * Возвращает null для всего остального.
 */
export function parseServerTime(raw, now = Date.now()) {
    const parsed = decodeMessage(raw);
    if (parsed === null)
        return null;
    const message = parsed;
    if (message.t === 'welcome') {
        const serverMs = finite(message.serverTime);
        // Старый сервер мог не называть время. Отсутствие поправки —
        // не поломка: таймер пойдёт по местным часам, возможно
        // со сдвигом, но пойдёт
        if (serverMs === null)
            return null;
        return { serverMs, roundTripMs: null };
    }
    if (message.t === 'pong') {
        const serverMs = finite(message.serverTs);
        if (serverMs === null)
            return null;
        // Метка отправки — наша собственная, и оборот считается по ней.
        // Отрицательный оборот означает, что часы переставили прямо
        // между отправкой и ответом: тогда лучше без поправки, чем
        // с выдуманной
        const sentAt = finite(message.ts);
        const trip = sentAt === null ? null : now - sentAt;
        return { serverMs, roundTripMs: trip !== null && trip >= 0 ? trip : null };
    }
    return null;
}
function finite(value) {
    if (typeof value !== 'number' || !Number.isFinite(value))
        return null;
    return value;
}
//# sourceMappingURL=clock.js.map